// This file is generated by pnpm icons:generate. Do not edit.

import {SettingsGear2_Stroke2_Corner0_Rounded as CanonicalSettingsGear2_Stroke2_Corner0_Rounded} from './Settings'

/** @deprecated Import SettingsGear2_Stroke2_Corner0_Rounded from `#/components/icons/Settings` instead. */
export const SettingsGear2_Stroke2_Corner0_Rounded =
  CanonicalSettingsGear2_Stroke2_Corner0_Rounded
